import React, { useContext } from 'react';
import { Form } from '@gulfwinds/ui-components';
import FormGridContext from './FormGridContext';

const GridInlineFormRow = ({
  dataItem,
  isInEdit,
  formDataIndex,
  validationSchema,
  validationContext,
  onSubmit,
  children,
}) => {

  const formGridContext = useContext(FormGridContext);

  if (isInEdit) {
    return (
      <Form
        key={JSON.stringify(dataItem)}
        initialValues={dataItem}
        validationSchema={validationSchema}
        validationContext={validationContext}
        onSubmit={onSubmit}
        ignoreModified={true}
        render={(props) =>
          <FormGridContext.Provider
            value={{ ...formGridContext, [dataItem[formDataIndex]]: props }}
          >
            {children}
          </FormGridContext.Provider>
        }
      />
    );
  }

  return children;
};

export default GridInlineFormRow;
